import { render, staticRenderFns } from "./TagSelector.vue?vue&type=template&id=dbcb612c&scoped=true"
import script from "./TagSelector.vue?vue&type=script&lang=js"
export * from "./TagSelector.vue?vue&type=script&lang=js"
import style0 from "./TagSelector.vue?vue&type=style&index=0&id=dbcb612c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcb612c",
  null
  
)

export default component.exports